import { render, staticRenderFns } from "./BoxTextarea.vue?vue&type=template&id=b43efb04&scoped=true&"
import script from "./BoxTextarea.vue?vue&type=script&lang=js&"
export * from "./BoxTextarea.vue?vue&type=script&lang=js&"
import style0 from "./BoxTextarea.vue?vue&type=style&index=0&id=b43efb04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43efb04",
  null
  
)

export default component.exports